export const SUPPORT_URLS = {
  SUPPORT_PAGE: 'https://www.compliance.ai/product-guides-iframe',
  CORPORATE_WEBSITE: 'https://www.compliance.ai/news/',
  ZOHO_TICKET: 'https://desk.zoho.com/portal/complianceai/'
};
